<div class="energy-pass" [nbSpinner]="loading() || saving()">
  @if (form(); as form) {
    <div class="energy-pass-content" [formGroup]="form">

      <div class="energy-pass-header">
        <wr-banner class="info-text"
                   status="info"
                   [icon]="{ icon: 'alert-circle-outline', pack: 'eva' }"
                   message="Sensoren oder Absolutwerte (mit Operator +/−) zusammenstellen. Die Brutto-Grundfläche teilt nur die Sensor-Verbräuche.">
        </wr-banner>
        <div class="header-actions">
          @if (editMode()) {
            <button nbButton status="primary" type="button" (click)="addEntry()"
                    nbTooltip="Eintrag hinzufügen" aria-label="Eintrag hinzufügen">
              <nb-icon pack="eva" icon="plus-outline"></nb-icon>
            </button>
          }
        </div>
      </div>

      @if (editMode() || hasCertificate()) {
        <div class="grid">
          <div class="md:col-3 field">
            <label class="label" for="livingArea">Brutto-Grundfläche (BGF) in m²</label>
            <input nbInput fullWidth id="livingArea" type="number" min="0" formControlName="livingArea" placeholder="z.B. 1200"
                   nbTooltip="Bezugsfläche für die Berechnung (Verbrauch ÷ Fläche), nur für Sensor-Einträge. Vorbelegt mit der Wohnnutzfläche aus den Gebäude-Stammdaten.">
          </div>
          <div class="md:col-3 field">
            <label class="label" for="heatingSystemType">Heizsystem</label>
            <nb-select fullWidth id="heatingSystemType" formControlName="heatingSystemType"
                       nbTooltip="Bestimmt die Klassengrenzen der Energieeffizienzklassen. Bei fossilen Heizsystemen ist Klasse A nicht erreichbar.">
              <nb-option value="DECARBONIZED">Dekarbonisiert</nb-option>
              <nb-option value="FOSSIL">Fossil</nb-option>
            </nb-select>
          </div>
          <div class="md:col-3 field">
            <label class="label" for="certifiedEnergyDemand">Endenergiebedarf laut Energieausweis (kWh/m²·a)</label>
            <input nbInput fullWidth id="certifiedEnergyDemand" type="number" min="0" formControlName="certifiedEnergyDemand"
                   placeholder="z.B. 95"
                   nbTooltip="Wert von der ersten Seite des Energieausweises (EEB, Standortklima). Wird im Dashboard neben dem Messwert angezeigt.">
          </div>
        </div>
      }

      <div class="entry-list">
        @for (entry of visibleEntries(); track entry) {
          <div class="entry-item" [formGroup]="entry">
            <button nbButton
                    type="button"
                    class="operator-button"
                    [class.readonly]="!editMode()"
                    [status]="entry.get('operator')?.value === 'PLUS' ? 'success' : 'danger'"
                    (click)="toggleOperator(entry)">
              {{ entry.get('operator')?.value === 'PLUS' ? '+' : '−' }}
            </button>

            <nb-select formControlName="type" class="type-select">
              <nb-option value="SENSOR">Sensor</nb-option>
              <nb-option value="ABSOLUTE">Absolutwert</nb-option>
            </nb-select>

            @if (entry.get('type')?.value === 'SENSOR') {
              <wr-sensor-installation-select class="value-control"
                                             formControlName="sensor"
                                             [buildingId]="buildingId()"
                                             [dimension]="'ENERGY'"
                                             [purposes]="sensorPurposes">
              </wr-sensor-installation-select>
              <div class="forecast-control">
                <label class="forecast-affix" [for]="'forecast-' + $index">Prognose</label>
                <input nbInput [id]="'forecast-' + $index" type="number"
                       formControlName="forecastValue" placeholder="optional">
                <span class="forecast-affix">kWh/m²·a</span>
                <nb-icon class="forecast-info" pack="eva" icon="info-outline" tabindex="0" role="img"
                         [nbTooltip]="forecastFieldHint" [attr.aria-label]="forecastFieldHint"></nb-icon>
              </div>
            } @else {
              <input nbInput class="value-control" type="number" formControlName="absoluteValue" placeholder="kWh/m²">
            }

            <input nbInput class="label-control" formControlName="label" placeholder="Bezeichnung (optional)">

            @if (editMode()) {
              <button nbButton ghost status="danger" type="button" (click)="removeEntry(entry)"
                      nbTooltip="Eintrag entfernen" aria-label="Eintrag entfernen">
                <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
              </button>
            }
          </div>
        }
        @if (!visibleEntries().length) {
          <div class="empty-hint">
            @if (editMode()) {
              Noch keine Einträge. Über das <nb-icon pack="eva" icon="plus-outline"></nb-icon> Symbol oben rechts können Sensoren oder Absolutwerte hinzugefügt werden.
            } @else {
              Noch keine Einträge hinterlegt.
            }
          </div>
        }
      </div>

      @if (warnings().length) {
        <wr-banner status="warning"
                   [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                   [message]="warningMessage()">
        </wr-banner>
      }

      @if (latest(); as latest) {
        <div class="preview">
          <div class="section">Effektiver Energiebedarf</div>
          <wr-energy-class-gauge [value]="latest.value"
                                 [certifiedValue]="certifiedEnergyDemand()"
                                 [energyClass]="latest.energyClass"
                                 [energyClasses]="energyClasses()"
                                 [periodStart]="latest.periodStart"
                                 [periodEnd]="latest.periodEnd"
                                 [breakdown]="latest.breakdown">
          </wr-energy-class-gauge>
        </div>
      }
    </div>
  }
</div>
